import React from 'react';
import { CTAButton } from './CTAButton';
const TOMOS = [{
  n: '1',
  emoji: '📘',
  title: 'Domina el Diagnóstico desde la Primera Consulta',
  text: 'Aprende a identificar el perfil clínico del paciente, solicitar los estudios adecuados y establecer un plan de tratamiento con una evaluación estructurada desde el primer día.',
  color: 'bg-navy'
}, {
  n: '2',
  emoji: '💊',
  title: 'Elige el Tratamiento Ideal con Total Confianza',
  text: 'Conoce cuándo iniciar tratamiento farmacológico, cómo seleccionar el medicamento más adecuado, realizar la titulación correcta y evitar errores frecuentes de prescripción.',
  color: 'bg-teal-700'
}, {
  n: '3',
  emoji: '🧪',
  title: 'Interpreta Laboratorios como un Experto',
  text: 'Descubre cómo convertir los resultados de laboratorio en decisiones clínicas prácticas mediante tablas, biomarcadores y criterios de interpretación basados en evidencia.',
  color: 'bg-purple-700'
}, {
  n: '4',
  emoji: '📈',
  title: 'Logra Resultados Duraderos sin Improvisar',
  text: 'Aprende a manejar mesetas de pérdida de peso, ajustar tratamientos, controlar efectos adversos y mantener la evolución clínica del paciente a largo plazo.',
  color: 'bg-orange-600'
}, {
  n: '5',
  emoji: '🩺',
  title: 'Resuelve los Casos Clínicos Más Desafiantes',
  text: 'Domina el manejo de pacientes con diabetes, hipertensión, resistencia a la insulina, obesidad severa, menopausia y otros escenarios que generan mayor incertidumbre.',
  color: 'bg-red-700'
}, {
  n: '6',
  emoji: '🧰',
  title: 'Acelera tus Consultas con Herramientas Listas para Usar',
  text: 'Obtén checklists, algoritmos, plantillas, tablas y recursos visuales que simplifican cada consulta y reducen el tiempo de toma de decisiones.',
  color: 'bg-brandblue'
}];
export function Tomos() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-225" data-mp="27znw1bed908g">
      <div className="mx-auto max-w-3xl" data-id="element-226" data-mp="282jvj45v3wz0">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-227" data-mp="1zz87p61rx9q6">
          ¿Qué contiene el Kit Clínico para el Manejo de la Obesidad?
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed text-navy/65" data-id="element-228" data-mp="29ygwlkhs7y5o">
          Una Ruta Clínica completa para acompañarte desde la evaluación inicial hasta el seguimiento
          a largo plazo.
        </p>

        <div className="mt-9 space-y-4" data-id="element-229" data-mp="2ix2nq41bkli2">
          {TOMOS.map(tomo => <article key={tomo.n} className="overflow-hidden rounded-2xl border border-navy-100 bg-cream shadow-sm" data-id="element-230" data-mp="2evz89in6orhd">
              <div className={`flex items-center gap-2 px-4 py-2.5 ${tomo.color}`} data-id="element-231" data-mp="2npc7t3fr6rcf">
                <span className="text-base" aria-hidden="true" data-id="element-232" data-mp="2nrf5m9n5dorp">
                  {tomo.emoji}
                </span>
                <span className="text-[12px] font-extrabold uppercase tracking-widest text-white" data-id="element-233" data-mp="2xni5t9yfvdc0">
                  Tomo {tomo.n}
                </span>
              </div>
              <div className="p-4 sm:p-5" data-id="element-234" data-mp="3h77c5oxd6xak">
                <h3 className="font-display text-[19px] font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-235" data-mp="3lbf37sraopby">
                  {tomo.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-236" data-mp="37d8dizwi1vnd">
                  {tomo.text}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-9 flex justify-center" data-id="element-237" data-mp="2xjhre1nuhxau">
          <CTAButton label="QUIERO LOS 6 TOMOS AHORA" sublabel="Acceso inmediato en PDF · Computadora, tablet y móvil" pulse={false} data-id="element-238" data-mp="32cugecwfs644" />
        </div>
      </div>
    </section>;
}